/** Seeded randomness (ENGINE-SPEC §1): xoshiro128**, seeded from the document hash via splitmix32. */
export function makeRng(seed: number): () => number {
	let s = seed >>> 0;
	const splitmix = () => {
		s = (s + 0x9e3779b9) >>> 0;
		let z = s;
		z = Math.imul(z ^ (z >>> 16), 0x85ebca6b) >>> 0;
		z = Math.imul(z ^ (z >>> 13), 0xc2b2ae35) >>> 0;
		return (z ^ (z >>> 16)) >>> 0;
	};
	let a = splitmix();
	let b = splitmix();
	let c = splitmix();
	let d = splitmix();
	const rotl = (x: number, k: number) => ((x << k) | (x >>> (32 - k))) >>> 0;
	return () => {
		const result = Math.imul(rotl(Math.imul(b, 5) >>> 0, 7), 9) >>> 0;
		const t = (b << 9) >>> 0;
		c = (c ^ a) >>> 0;
		d = (d ^ b) >>> 0;
		b = (b ^ c) >>> 0;
		a = (a ^ d) >>> 0;
		c = (c ^ t) >>> 0;
		d = rotl(d, 11);
		return result / 4294967296;
	};
}
